<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83398 7.5013V2.5013C5.83398 2.26519 5.91385 2.06727 6.07357 1.90755C6.23329 1.74783 6.43121 1.66797 6.66732 1.66797C6.90343 1.66797 7.10135 1.74783 7.26107 1.90755C7.42079 2.06727 7.50065 2.26519 7.50065 2.5013V7.5013H8.33398V2.5013C8.33398 2.26519 8.41385 2.06727 8.57357 1.90755C8.73329 1.74783 8.93121 1.66797 9.16732 1.66797C9.40343 1.66797 9.60135 1.74783 9.76107 1.90755C9.92079 2.06727 10.0007 2.26519 10.0007 2.5013V7.5013C10.0007 8.27908 9.76107 8.95964 9.2819 9.54297C8.80273 10.1263 8.20898 10.5152 7.50065 10.7096V17.5013C7.50065 17.7374 7.42079 17.9353 7.26107 18.0951C7.10135 18.2548 6.90343 18.3346 6.66732 18.3346C6.43121 18.3346 6.23329 18.2548 6.07357 18.0951C5.91385 17.9353 5.83398 17.7374 5.83398 17.5013V10.7096C5.12565 10.5152 4.5319 10.1263 4.05273 9.54297C3.57357 8.95964 3.33398 8.27908 3.33398 7.5013V2.5013C3.33398 2.26519 3.41385 2.06727 3.57357 1.90755C3.73329 1.74783 3.93121 1.66797 4.16732 1.66797C4.40343 1.66797 4.60135 1.74783 4.76107 1.90755C4.92079 2.06727 5.00065 2.26519 5.00065 2.5013V7.5013H5.83398ZM14.1673 11.668H12.5007C12.2645 11.668 12.0666 11.5881 11.9069 11.4284C11.7472 11.2687 11.6673 11.0707 11.6673 10.8346V5.83464C11.6673 4.86241 12.025 3.92491 12.7402 3.02214C13.4555 2.11936 14.1951 1.66797 14.959 1.66797C15.209 1.66797 15.4173 1.76519 15.584 1.95964C15.7507 2.15408 15.834 2.38325 15.834 2.64714V17.5013C15.834 17.7374 15.7541 17.9353 15.5944 18.0951C15.4347 18.2548 15.2368 18.3346 15.0007 18.3346C14.7645 18.3346 14.5666 18.2548 14.4069 18.0951C14.2472 17.9353 14.1673 17.7374 14.1673 17.5013V11.668Z"
      fill="#F18E35"
    />
  </svg>
</template>

<script>
export default {
  name: "CuisineCateringIcon",
};
</script>

<style scoped></style>
